import axios from 'axios'
import store from '@/store'

const API_BASE_URL = process.env.VUE_APP_API_URL || 'https://clubtest.intrare.app'

const headers = () => ({
  'Content-Type': 'application/json',
  'Accept-Language': store.state.language,
  'authorization': 'Token ' + store.getters.getToken
})

export const getPendingInvitations = () => axios({
  method: 'get',
  url: `${API_BASE_URL}/invitations/pending/`,
  headers: headers()
})

export const getCurrentInvitations = () => axios({
  method: 'get',
  url: `${API_BASE_URL}/invitations/current/`,
  headers: headers(),
  params: {
    status: 'all',
    limit: 500
  }
})

export const approveInvitation = id => axios({
  method: 'post',
  url: `${API_BASE_URL}/invitation/approve/${id}/`,
  headers: headers()
})

export const rejectInvitation = (id, reason) => axios({
  method: 'post',
  url: `${API_BASE_URL}/invitation/reject/${id}/`,
  headers: headers(),
  data: { reason }
})
